module.exports = __webpack_public_path__ + "img/d-zdy.edf43b76.png";